export type CardComponent = 'a' | 'div'

export interface CardNavigation {
  url: string
  target?: '_blank'
  rel?: string
}

export const getCardComponent = (navigation?: CardNavigation): CardComponent => {
  if (navigation) {
    return 'a'
  }
  return 'div'
}
